import { render } from "./OptionText.vue?vue&type=template&id=697b20dc"
import script from "./OptionText.vue?vue&type=script&lang=js"
export * from "./OptionText.vue?vue&type=script&lang=js"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__